import {FC} from 'react'
import {useIntl} from 'react-intl'
import {ID} from '../../crud-helper/models'
import {ErrorMessage} from '../../../../app/modules/errors/formikMessages/errorMessages'

interface FormSelectProps<T> {
  idOption?: ID
  name: string
  label: string
  data: T[]
  formik: any
  idKey: keyof T
  nameKey: keyof T
  disabled?: boolean
}

const FormSelect: FC<FormSelectProps<any>> = ({
  idOption,
  name,
  label,
  data,
  formik,
  idKey,
  nameKey,
  disabled = false,
}) => {
  const intl = useIntl()

  return (
    <div className='form-floating col-12 my-3 px-1'>
      <select
        className='form-select form-select-solid'
        data-kt-select2='true'
        data-placeholder={intl.formatMessage({id: label})}
        data-allow-clear='true'
        data-hide-search='true'
        onChange={(e) => {
          formik.setFieldValue(name, e.target.value)
        }}
        value={idOption?.toString()}
        disabled={disabled}
      >
        <option value='' disabled selected>
          {' '}
          {intl.formatMessage({id: label})}{' '}
        </option>
        {data?.map((item) => (
          <option key={String(item[idKey])} value={String(item[idKey])}>
            {String(item[nameKey])}
          </option>
        ))}
      </select>
      <label htmlFor={name}>{intl.formatMessage({id: label})}</label>
      {formik.touched[name] && formik.errors[name] && (
        <ErrorMessage errorMessage={intl.formatMessage({id: formik.errors[name]})} />
      )}
    </div>
  )
}

export default FormSelect
